import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from "@mui/material";
import { Close, InformationOutline } from "mdi-material-ui";
import Icon from '../../../Icon';
import ToLocalString from "../../../ToLocalString";
import PropTypes from "prop-types";
function CalendarHeader(props) {
    const { mediaName, mediaOptionName, toolName, units, unitsName, unitPrice, totalPrice, handleClose } = props;
    return (_jsxs(Box, Object.assign({ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2.5 }, { children: [_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", gap: 2 }, { children: [_jsx(Icon, { iconName: toolName, width: 24, height: 24, color: "#172B4D" }), _jsxs(Typography, Object.assign({ variant: "h4" }, { children: [mediaOptionName, " on ", mediaName] }))] })), _jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", gap: 5 }, { children: [_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", gap: 1 }, { children: [_jsxs(Typography, Object.assign({ variant: "subtitle2" }, { children: ["#total ", unitsName] })), _jsx(InformationOutline, { sx: { color: "text.light", fontSize: "16px" } })] })), _jsx(Typography, Object.assign({ variant: "h5" }, { children: units })), _jsxs(Typography, Object.assign({ variant: "subtitle2" }, { children: ["Subtotal ", _jsx(ToLocalString, { number: unitPrice, currency: true }), " x ", units] })), _jsx(Typography, Object.assign({ variant: "h5", fontWeight: "fontWeightSemiBold" }, { children: _jsx(ToLocalString, { number: totalPrice, currency: true }) })), _jsx(Close, { color: "primary", sx: { pl: 2, cursor: "pointer" }, onClick: handleClose })] }))] })));
}
CalendarHeader.propTypes = {
    mediaName: PropTypes.string,
    mediaOptionName: PropTypes.string,
    toolName: PropTypes.oneOf([
        "airport",
        "cinema",
        "digital",
        "hyperlocal",
        "influencer-marketing",
        "magazine",
        "newspaper",
        "nontraditional",
        "outdoor",
        "radio",
        "television",
    ]),
    units: PropTypes.number,
    unitsName: PropTypes.string,
    unitPrice: PropTypes.number,
    totalPrice: PropTypes.number,
};
export default CalendarHeader;
